import React from "react"
import {Link} from "react-router-dom"
import {
    checkAllowed,
    contextMenuItem,
    getThumbUrlOfExt,
    isCloudinaryUrl,
    isGoogleDiskPdf,
    isValidUrl,
    objectLang, proxyImage,
    setImagesDataToSlider,
    setPathBack
} from "../functions"
import {MenuItem} from "./MenuItem"
import flagCheckEmpty from "../images/check-empty.png"
import {createBrowserHistory} from "history"
import img_context_menu from "../images/context-menu.png"

export class LinkElement extends React.Component {

    render() {

        const l = objectLang().language.lang
        let {k, auth, owner, item, documents} = this.props

        const link = item
        let flag = false, linkSmall = '', div_name_link = '', imgLink = item.thumbUrl
        if (imgLink && imgLink.includes("link-logo-default")) {
            imgLink = getThumbUrlOfExt(item.from)
        }
        if (imgLink && imgLink.includes("link-logo-default")) {
            if (isValidUrl(item.from)) {
                linkSmall = new URL(link.from).host + new URL(link.from).pathname
                flag = true
                div_name_link = 'div-name-link'
            }
        }
        if (!imgLink.startsWith('/static/media') &&
            !imgLink.startsWith('data:image/png')) {
            imgLink = proxyImage(imgLink)
        }
        link.parentFolder = item.parentFolder

        let checkIcon = flagCheckEmpty

        const menuItemData = {
            key: k,
            item: 'link',
            id: link["_id"],
            link: link.from,
            parent: link.parentFolder,
            from: 'view',
            name: item.name,
            thumb: imgLink
        }

        let from = link.from
        if (isCloudinaryUrl(link.from)) {
            from = `/${l}/link/image-slide/${link._id}`
        }
        if (isGoogleDiskPdf(link)) {
            const enc = (v) => encodeURIComponent(v || '')
            if (auth.authenticatedVia === 'google') {
                from = `/${l}/google-drive-view/from?link=${enc(link['from'])}&mime-type=${enc('application/pdf')}&linkViewImage=${enc(link['linkViewImage'])}`
            }
        }

        return (
            <div>
                <div className={"d-flex justify-content-center position-relative"}>
                    <Link to={from}
                          style={{minWidth: "72px"}}
                          className={'link-link'}
                          onContextMenu={(e) => {
                              if (checkAllowed(auth, documents.owner)) {
                                  contextMenuItem(e, k)
                              }
                          }}
                          target={"_blank"}
                          rel={"noreferrer noopener"}>
                        <div className={'hand-click'}
                             onContextMenu={(e) => {
                                 if (checkAllowed(auth, documents.owner)) {
                                     contextMenuItem(e, k)
                                 }
                             }}
                             onClick={() => {
                                 setImagesDataToSlider(documents.links)
                                 setPathBack(createBrowserHistory().location.pathname)
                             }}>
                            <div className={"img-wrapper"}>
                                <img
                                    id={"img-link"}
                                    src={imgLink}
                                    className={"img-link"}
                                    alt={"LINK"}
                                />
                            </div>
                        </div>
                    </Link>
                    <div className={'check-icon'}>
                        <img id={`img-check-item-${k}`} src={checkIcon}
                             className={"img-check w-100 rounded-2"}
                             alt={"..."}/>
                    </div>
                    <div className={'hand-click'}
                         onClick={(e) => {
                             if (checkAllowed(auth, documents.owner)) {
                                 contextMenuItem(e, k)
                             }
                         }}>
                        {(!item.isShare || owner === 'trial-user') &&
                        <img id={"img-context-menu"} src={img_context_menu}
                             className={"w-100 rounded-2"}
                             alt={"..."}/>}
                    </div>
                    {<MenuItem data={menuItemData}/>}
                </div>
                {flag && <div className={'pe-2'}>
                    <a href={from}
                       className={'text-decoration-none'}
                       target={"_blank"}
                       rel={"noreferrer noopener"}
                       onContextMenu={(e) => {
                           if (checkAllowed(auth, documents.owner)) {
                               contextMenuItem(e, k)
                           }
                       }}>
                        <p id={'p-link-from'}
                           className={'text-black text-link me-2 overflow-hidden'}>
                            <span id={'link-from'}>{linkSmall}</span>
                        </p>
                    </a>
                </div>}
                <div className={div_name_link}>
                    <p id={"name-link"}
                       className={"name-link text-center mb-2 text-black p-0 fw-bold"}>{link.name}
                    </p>
                </div>
            </div>
        )
    }
}